var map = {
	"./accounts.png": 9864,
	"./crm.jpeg": 4763,
	"./employee.png": 4748,
	"./hospital_icon.png": 3600,
	"./hotel.png": 664,
	"./human-resource.jpg": 4644,
	"./image1.jpg": 9928,
	"./image2.jpg": 855,
	"./images.png": 9966,
	"./inventor_img.png": 9887,
	"./inventory.png": 5842,
	"./kalitech.png": 8701,
	"./logo.png": 3153,
	"./member 2.png": 812,
	"./member.png": 4614,
	"./membership.jpeg": 3033,
	"./module_pics/property_sale.png": 7612,
	"./module_pics/sales.jpeg": 9584,
	"./module_pics/sales_agent.png": 509,
	"./module_pics/vehicle_sales.jpeg": 5427,
	"./rent.png": 865,
	"./sales.jpeg": 2619,
	"./sales.png": 1706,
	"./settings.jpeg": 816,
	"./vehicle_sales.jpeg": 8816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;